<template>
  <div>
  <div class="content">
   
    <b-container fluid class="mt-4">
    
      <stats-card title="Orchards" type="default" sub-title="All orchards" icon="fas fa-tree">

        <template slot="actions">
            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Create new</a>
        </template>

        <template slot="append">

          <base-alert>
            Last 10 orchards created displayed here. Use the search bar below to fetch more.
          </base-alert>

          <div class="mt-4">
            <entity-picker v-if="groupData.length > 0"
                :key="groupPicker"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getGroups"
                :cursorData="cursorData"
                :selected="groupData"
                :filters="tableFilters"
                editPath="/groups/"
                :tableOptions="tableOptions"
                :tableColumns="tableColumns"
                :canExport="true"
                rootProp="orchards"
            >
            </entity-picker>
          </div>
        </template>
      </stats-card>
    </b-container>
  </div>


    <modal :show.sync="showCreateModal">
        <h6 slot="header" class="modal-title">Create Orchard</h6>

        <entity-picker v-if="groupData.length > 0"
            :key="farmPicker"
            :canEdit="false"
            :multiple="false"
            :canSelect="true"
            rootProp="farms"
            placeHolder="Select this orchard's parent farm"
            apiEndpoint="getFarms"
            @onSelect="onGroupCreateFarmSelect"
        >
        </entity-picker>

        <div v-if="newGroup.farmId != null">
            <base-input label="Orchard name:" v-model="newGroup.name"></base-input>
            <base-input label="Contact email:" v-model="newGroup.email"></base-input>
            <div class="form-group">
                <label class="form-control-label">Timezone:</label>
                <b-form-select v-model="newGroup.timezone" :options="timezones"></b-form-select>
            </div>

            <div class="form-check" v-if="newGroupFarm != null && newGroupFarm.location.isValid">
                <input type="checkbox" @change="toggleNewGroupLocation"  class="form-check-input" id="copyLocationFromParent">
                <label class="form-check-label" for="copyLocationFromParent"><small>Copy location from parent farm</small></label>
                <a title="View on Google Maps" class="ml-2" target="_blank" :href="`https://www.google.com/maps/place/${newGroupFarm.location.lat},${newGroupFarm.location.lon}`"><i class="el-icon-map-location"></i></a>
            </div>

            <div class="form-check" v-if="newGroupFarm != null && newGroupFarm.address.isPopulated">
                <input type="checkbox" @change="toggleNewGroupAddress" class="form-check-input" id="copyAddressFromParent">
                <label class="form-check-label" for="copyAddressFromParent"><small>Copy address from parent farm</small></label>
                <el-popover
                  placement="top-start"
                  title="Parent address"
                  width="200"
                  trigger="hover"
                  :content="`${newGroupFarm.address.lineOne}\n${newGroupFarm.address.city}`">
                    {{newGroupFarm.address.lineOne}} {{newGroupFarm.address.lineTwo}}<br>
                    {{newGroupFarm.address.city}} {{newGroupFarm.address.postcode}} {{newGroupFarm.address.state}}
                  <i class="ml-2 el-icon-info" slot="reference"></i>
                </el-popover>
            </div>

        </div>

        <template slot="footer">
            <base-button type="blank" @click="showCreateModal = false">Cancel</base-button>
            <base-button :disabled="false" type="success" @click="createNewGroup">Create Orchard</base-button>
        </template>
    </modal>
  </div>

</template>


<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/GroupTable'
import { GroupModel } from '@/models/group/group'
import { FarmModel } from '@/models/farm/farm'
import { FormAddress } from '@/models/common/address'
import { LocationModel } from '@/models/common/location'
import { timezones } from '@/config/Time'

export default {
  components: {
  },
  data() {
    return {
      groupData: [],
      showCreateModal: false,
      groupCreateFarmId: null,
      groupCreateGroupName: '',
      newGroup: new GroupModel(),
      tableFilters: tableFilters,
      tableColumns: tableColumns,
      tableOptions: tableOptions,
      cursorData: null,
      timezones: timezones,
      newGroupFarm: null
    }
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getGroups({
      sort: this.tableOptions['default-sort'].prop,
      direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
      limit: this.tableOptions.limit || 10
    })
    this.$emit('loading', false);
    this.groupData = results.orchards;
    this.cursorData = results.cursor 
  },
  methods: {
    toggleNewGroupAddress(event) {
      if(event.target.checked) {
        this.newGroup.address = this.newGroupFarm.address
      }
      else {
        this.newGroup.address = new FormAddress()
      }
    },
    toggleNewGroupLocation(event) {
      if(event.target.checked) {
        this.newGroup.location = this.newGroupFarm.location
      }
      else {
        this.newGroup.location = new LocationModel()
      }
    },
      onGroupCreateFarmSelect(farmId) {
          this.newGroupFarm = new FarmModel(farmId[0])
          this.newGroup.farmId = this.newGroupFarm.id
          console.log(this.newGroupFarm)
      },
      createNewGroup: async function() {

        this.showCreateModal = false
        this.$emit('loading', true);

        // console.log(this.newGroup.exportToCreate())

        const createGroup = await api.createGroup(this.newGroup.exportToCreate());
        
        this.$emit('loading', false);
        this.$emit('onApiResult', 'Orchard created, redirecting you to it...');
        this.$router.push(`/groups/${createGroup.id}?created`);
      }
  }
};
</script>
